module.exports = __webpack_public_path__ + "1792395595471/images/logo.cb067f8.png";